import { createReducer, on } from '@ngrx/store';
import * as VolunteersActions from './volunteers.actions';
import { initialVolunteersState } from './volunteers.state';

export const volunteersReducer = createReducer(
  initialVolunteersState,
  on(VolunteersActions.loadVolunteerOfMonth, (state) => ({
    ...state,
    loading: true,
  })),
  on(VolunteersActions.loadVolunteerOfMonthSuccess, (state, { volunteerOfMonth }) => ({
    ...state,
    volunteerOfMonth,
    loading: false,
    error: null,
  })),
  on(VolunteersActions.loadVolunteerOfMonthFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
